<template>
  <div class="box">
    <div class="content" v-for="(item, index) in dataArr" :key="index">
      <div class="logo">
        <img :src="item.companyLogo" alt="" />
      </div>
      <!-- 公司名 -->
      <p class="Company-name">{{ item.companyName }}</p>
      <!-- 职位名 -->
      <p class="Company-name Job-title">{{ item.positionName }}</p>
      <!-- 时间地点 -->
      <div class="Time-place">
        <p>面试时间：{{ item.interviewTime }}</p>
        <p>面试地点：{{ item.interviewAddress }}</p>
      </div>
      <!-- 定位icon -->
      <p class="orientation-icon">
        <i class="el-icon-map-location"></i>
      </p>
      <!-- 聊天icon -->
      <p class="chat-icon"></p>
      <!-- 状态 -->
      <p
        class="schedule"
        :style="
          item.interviewStatus == '4'
            ? 'color: #FE574A;'
            : item.interviewStatus == '-1'
            ? 'color: #333333;'
            : item.interviewStatus == '3'
            ? 'color: #FF9601;'
            : 'color: #409eff ;'
        "
      >
        {{
          item.interviewStatus == "4"
            ? "未面试"
            : item.interviewStatus == "-1"
            ? "待面试"
            : item.interviewStatus == "3"
            ? "已面试"
            : "进行中"
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataArr: {},
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;

  .content:hover {
    box-shadow: 0px 0px 3px 0px #3291f8;
  }

  .content {
    width: 100%;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    margin-bottom: 20px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    div {
      cursor: pointer;
    }
    p {
      cursor: pointer;
    }
    // 公司logo
    .logo {
      width: 50px;
      height: 50px;
      margin: auto 0;
      margin-left: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 公司名
    .Company-name {
      width: 120px;
      height: 80px;
      line-height: 80px;
      margin-left: 10px;
      font-size: 14px;
      color: #333300;
      white-space: nowrap; //不换行
      overflow: hidden; //超出部分隐藏
      text-overflow: ellipsis; //文本溢出显示省略号
    }
    // 职位名称
    .Job-title {
      font-size: 16px;
      color: #409eff ;
    }
    // 时间 地址
    .Time-place {
      width: 300px;
      height: 50px;
      margin-left: 30px;
      margin: auto 0;
      p {
        height: 25px;
        line-height: 25px;
        font-size: 14px;
        color: #333300;
        white-space: nowrap; //不换行
        overflow: hidden; //超出部分隐藏
        text-overflow: ellipsis; //文本溢出显示省略号
      }
    }
    // 定位icon
    .orientation-icon {
      width: 30px;
      height: 30px;
      margin: auto 0;
      margin-left: 40px;
      i {
        font-size: 30px;
        color: #666666;
      }
    }
    //聊天icon
    .chat-icon {
      width: 30px;
      height: 28px;
      margin: auto 0;
      background-image: url("../../../../assets/imgs/buzaixiangoutong@3x.svg");
      background-size: 100% 100%;
      margin-left: 30px;
    }
    // 进度
    .schedule {
      flex: 1;
      height: 80px;
      line-height: 80px;
      margin-left: 30px;
      text-align: right;
      margin-right: 20px;
      font-size: 16px;
    }
  }
}
</style>
